import React from 'react'

type PendingClaimCardProps = {
  email: string
  isWithdrawing?: boolean
  onWithdraw: () => void
}

export const PendingClaimCard: React.FC<PendingClaimCardProps> = ({ email, isWithdrawing, onWithdraw }) => {
  return (
    <div className="overflow-hidden rounded-xl border border-amber-100 bg-[#FFF8E1]">
      <div className="border-l-4 border-[#D17D44] px-4 py-4 sm:px-5 sm:py-4">
        <p className="text-xs leading-relaxed text-gray-600">
          <span className="font-semibold text-graphite-grey">Your claim is under review.</span> We&apos;ll email {email}{' '}
          when it&apos;s approved — usually within two business days.
        </p>
        <button
          type="button"
          onClick={onWithdraw}
          disabled={isWithdrawing}
          className="mt-3 inline-flex items-center justify-center rounded-full border border-graphite-grey px-5 py-2 text-sm font-semibold text-graphite-grey transition-colors hover:bg-black/5 disabled:opacity-60"
        >
          {isWithdrawing ? 'Withdrawing…' : 'Withdraw claim'}
        </button>
      </div>
    </div>
  )
}
